module.exports = __webpack_public_path__ + "img/toastr-img-success.138dd689.svg";